<div
  *ngIf="isReportData(data)"
  class="report-type-container"
  [ngClass]="isSelected ? 'active' : ''">
  <div #controlBlock
       class="control-block block"
       [ngClass]="isSelected ? 'active' : ''"
       (click)="emitReportTypeChange()"
  >
    <div class="radio-wrapper">
      <app-custom-radio
        [alignTop]="true"
        [value]="data.id"
        (change)="emitReportTypeChange()"
        [checked]="isSelected"
      >{{data.title}}</app-custom-radio>
      <label>{{data.audience}}</label>
    </div>

    <button (click)="handleSample($event)">Sample report</button>

    <p class="description">
      {{data.description}}
    </p>
  </div>

  <div #featuresList
       class="features-list block"
       [class.extended]="isFeaturesExtended"
  >

    <button class="link-like-text"
            (click)="extendFeature()">
      {{ isFeaturesExtended ? 'Hide' : "What's included" }}</button>

    <ul *ngIf="isFeaturesExtended">
      @for (feature of data.features; track feature) {
        <li>
          <div class="checkmark-wrapper" app-icon-button iconSize="10px">
            <app-icon svgIcon="check"></app-icon>
          </div>
          {{feature}}
        </li>
      }
    </ul>
  </div>

  <div #additionalInfo class="additional-info block"  [class.increase-height]="isHeightIncreased">
    @if (reportsService.pricesData; as prices) {
      @let coupons = prices.userAvailableCoupons ? prices.userAvailableCoupons [data.id] : null;
      @let freeReports = coupons && coupons > 0;
      @let price = prices.reportPricesUsd[data.id];

      @if (!readyToOrder) {
        <span>To request a report, please contact us at <a class="link-like-text" href="mailto:info@map-ai.co">info&#64;map-ai.co</a></span>
      } @else {
        <div>
          @if (freeReports) {
            <span>Interactive report + PDF file are included in your subscription</span>
            <span class="price">Available for free: {{coupons}}</span>
          } @else {
            <span>Interactive report + PDF file:</span>
            <span class="price">{{price | currency:'USD':'symbol':'1.2-2'}}</span>
          }
        </div>
      }
    } @else {
      <div class="skeleton">
        <div class="skeleton"></div>
        <div class="skeleton"></div>
      </div>
    }
  </div>
</div>

<div *ngIf="!isReportData(data)"
     class="report-type-container subscription-plans"
     [class.side-panel]="isSidePanel"
     [ngClass]="isSelected ? 'active' : ''">
  <div #controlBlock
       class="control-block block"
       [ngClass]="isSelected ? 'active' : ''"
       (click)="emitReportTypeChange()"
  >

    <div class="radio-wrapper">
      <span [innerHTML]="data.title"></span>
      <label>{{data.audience}}</label>
    </div>

<!--    <div title='Tokens are pieces of words. We pay for AI based on the number of tokens used.-->
<!--    Messages can be bigger or smaller.-->
<!--    This is why number of messages is approximate.'>-->
<!--      <span *ngIf='isPeriodMonthly'>{{data.priceInfo.aiTokensMonthly}}</span>-->
<!--      <span *ngIf='!isPeriodMonthly'>{{data.priceInfo.aiTokensYearly}}</span>-->
<!--    </div>-->
    <ng-container *ngIf="!data.priceInfo.contactUsOnly">
      <div class="price-block" [class.price-with-discount]="!isPeriodMonthly && !freePeriodString">
        <ng-container *ngIf="!freePeriodString">
        <div *ngIf="!isPeriodMonthly">
          <span class="crossed-out-price">{{ data.priceInfo.priceMonthAnnually }}</span>
          <span class="yearly-discount-percents">{{ data.priceInfo.yearlyDiscountPercents }}</span>
        </div>
        <div class="current-price" *ngIf='!data.priceInfo.isPackage'>
          <span class="price-value">{{ isPeriodMonthly ? data.priceInfo.priceMonthly : data.priceInfo.priceYearly }}</span>
          <span class="period">{{ isPeriodMonthly ? '/month' : '/year' }}</span>
        </div>
        <div class="current-price" *ngIf='data.priceInfo.isPackage'>
            <span class="price-value">{{ data.priceInfo.pricePackage }}</span>
            <span class="period">Once</span>
        </div>
        </ng-container>

        <div *ngIf="freePeriodString" class="promo-price">
          <div style="display: flex; gap: 10px">
            <span class="crossed-out-price">{{ isPeriodMonthly ? data.priceInfo.priceMonthly : data.priceInfo.priceMonthAnnually }}</span>
          </div>
          <div class="current-price">
            <span class="price-value">$0</span>
            <span class="period">/ {{ freePeriodString }}</span>
          </div>
        </div>
      </div>

      <button (click)="handleSubscription(data.id)"
              [disabled]="isThisSubscriptionActive"
      >{{isThisSubscriptionActive ? 'Active' : ($any(data).regionalPricing ? 'Choose coverage area' : (isPeriodMonthly ? 'Get started' : 'Buy now & save')) }}
      </button>
    </ng-container>

    <div *ngIf="data.priceInfo.contactUsOnly" class="contact-us-pricing">
      <a class="link-like-text" href="mailto:info@map-ai.co">Contact us</a>
      <span> to get custom pricing</span>
    </div>
  </div>

  <div #featuresList
       class="features-list block"
       *ngIf="!isSidePanel"
       [class.extended]="isSeeIndicatorsActive"
  >

    <ul>
      @for (text of data.accessibleFeatures.plainTextFeatureDescription; track text) {
        <li class="accessible-feature">
          <div class="checkmark-wrapper" app-icon-button iconSize="10px">
            <app-icon svgIcon="check"></app-icon>
          </div>
          {{text}}
        </li>
      }
      <li class="accessible-feature">
        <div class="checkmark-wrapper" app-icon-button iconSize="10px">
          <app-icon svgIcon="check"></app-icon>
        </div>
        {{data.accessibleFeatures.indicatorsDescription.description}}
      </li>
      <button (click)="toggleIndicators()"
            class="show-indicators-btn"
      >{{isSeeIndicatorsActive ? 'Hide indicators' : 'See all indicators'}}</button>
      @for (group of data.accessibleFeatures.indicatorsDescription.groups; track group) {
        <ng-container *ngIf="isSeeIndicatorsActive">
          <mat-expansion-panel #panel="matExpansionPanel">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span>{{ group.groupTitle }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="bulleted" [class.expanded]="panel.expanded">
              <li *ngFor="let item of group.bulletList">{{ item }}</li>
            </ul>
          </mat-expansion-panel>
        </ng-container>
      }

      @for (feature of data.inaccessibleFeatures; track feature) {
        <li class="inaccessible-feature">
          <div class="checkmark-wrapper" app-icon-button iconSize="10px">
          </div>
          {{feature}}
        </li>
      }

      <ng-container *ngFor="let report of !data.reportsDescription.reportsMonthly ? data.reportsDescription.reportsBase : (isPeriodMonthly ? data.reportsDescription.reportsMonthly : data.reportsDescription.reportsYearly ); last as isLast">
        <li class="accessible-feature" *ngIf="report.reportsIncludedDescription">
          <div class="reports-description">
            <div class="checkmark-wrapper" app-icon-button iconSize="10px">
              <app-icon svgIcon="check"></app-icon>
            </div>
            <span>{{ report.reportsIncludedDescription }}</span>
          </div>
        </li>

        <li class="inaccessible-feature" *ngIf="report.reportsPaidDescription">

          <div class="reports-description">
            <div class="checkmark-wrapper" app-icon-button iconSize="10px">
            </div>
            <span class="not-included-reports">{{ report.reportsPaidDescription }}</span>
          </div>
        </li>

        <li *ngIf="report.sampleURL" >
          <a class="link-like-text download-sample" href="{{report.sampleURL}}" target="_blank" (click)="onSampleReportClick()">Download sample report</a>
        </li>

        <li *ngIf="!report.isReadyToOrder" >
          <span class="contact-us-note">(Contact us at <a class="link-like-text" href="mailto:info@map-ai.co">info map-ai.co</a> to order)</span>
        </li>
      </ng-container>


    </ul>
  </div>
</div>
